import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/services/dashboard.service';
import { AlertService } from 'app/shared/alert/alert.service';
import { ShiftDataService } from '../shift-data.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-category-filter-dialog',
  templateUrl: './category-filter-dialog.component.html',
  styleUrls: ['./category-filter-dialog.component.scss']
})
export class CategoryFilterDialogComponent implements OnInit {

  categories:any[]=[];
  selectedCategoryIdsForFilter :any[]=[];
  selectedSiteDetails:any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  
  constructor(public dialogRef: MatDialogRef<CategoryFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dashboardService : DashboardService,
    private alertService: AlertService,
    private shiftDataService : ShiftDataService) {
      this.getCategoryData();
   }

  ngOnInit(): void {
  }

  getCategoryData(){
    let categories : any = localStorage.getItem("categories");
    if(categories != '' && categories != null && categories != undefined){
      this.categories = JSON.parse(categories);
    }
  }

  categorySelected(category : any,event:any){
    this.shiftDataService.selectedCategoryIdsForFilter =
    this.shiftDataService.selectedCategoryIdsForFilter.filter((a) => +a.category_id == +category.category_id).length > 0
        ? this.shiftDataService.selectedCategoryIdsForFilter.filter((a) => +a.category_id != +category.category_id)
        : [...this.shiftDataService.selectedCategoryIdsForFilter, category];

        
      if(category.assets.length > 0 && event.checked){
        category.assets.forEach((asset) => {
          this.shiftDataService.selectedAssetIdsForFilter =
          this.shiftDataService.selectedAssetIdsForFilter.filter((a) => +a.asset_id == +asset.asset_id).length > 0
                ? this.shiftDataService.selectedAssetIdsForFilter.filter((a) => +a.asset_id != +asset.asset_id)
                : [...this.shiftDataService.selectedAssetIdsForFilter, asset];
          });
        } 
      if(!event.checked){
        category.assets.forEach((asset) => {
          if (this.shiftDataService.selectedAssetIdsForFilter.some((a) => +a.asset_id === +asset.asset_id)) {
            // Remove the matching asset
            this.shiftDataService.selectedAssetIdsForFilter = 
              this.shiftDataService.selectedAssetIdsForFilter.filter((a) => +a.asset_id !== +asset.asset_id);
          }
        });        
      }
  }

  isChecked(category: any) {
    return !!this.shiftDataService.selectedCategoryIdsForFilter.filter((a) => a.category_id == category.category_id).length;
  }

  onSubmitClick(){
    this.shiftDataService.applyCategoryFilters(this.shiftDataService.selectedCategoryIdsForFilter);
    this.shiftDataService.applyAssetFilters(
      this.shiftDataService.selectedAssetIdsForFilter,this.shiftDataService.selectIssueType
    );
    this.dialogRef.close();
  }
}
